import { useEffect, useState } from "react";
import { menuItems as fallbackMenu, services as fallbackServices } from "../config/catalog";
import { getMenu, getServices } from "../lib/api";
import type { MenuItem, Service } from "../types";

export function useCatalog() {
  const [menu, setMenu] = useState<MenuItem[]>(fallbackMenu);
  const [services, setServices] = useState<Service[]>(fallbackServices);

  useEffect(() => {
    void getMenu().then(setMenu);
    void getServices().then(setServices);
  }, []);

  return {
    menu: menu.filter((item) => item.active).sort((a, b) => a.sortOrder - b.sortOrder),
    services: services.filter((service) => service.active).sort((a, b) => a.sortOrder - b.sortOrder)
  };
}
